import { createContext, RefObject } from 'react';

import { useSettingsDrawerState } from './_hooks/useSettingsDrawerState';

export const SettingsDrawerContext = createContext<
  ReturnType<typeof useSettingsDrawerState> & {
    lockedGroupRef: RefObject<HTMLElement | null>;
    unlockedGroupRef: RefObject<HTMLElement | null>;
  }
>({} as never);
